const PrevIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.8252 14.3249C10.6752 14.3249 10.5252 14.2749 10.4252 14.1499L4.7752 8.3999C4.5502 8.1749 4.5502 7.8249 4.7752 7.5999L10.4252 1.8499C10.6502 1.6249 11.0002 1.6249 11.2252 1.8499C11.4502 2.0749 11.4502 2.4249 11.2252 2.6499L5.9752 7.9999L11.2502 13.3499C11.4752 13.5749 11.4752 13.9249 11.2502 14.1499C11.1002 14.2499 10.9752 14.3249 10.8252 14.3249Z'
        fill='#9CA3AF'
      />
    </svg>
  );
};

export default PrevIcon;
